"use strict";

exports.__esModule = true;
exports.justifyClasses = exports.getJustifyClasses = exports.default = exports.JUSTIFY = void 0;
var _mediaQuery = require("../../utils/mediaQuery");
let JUSTIFY = exports.JUSTIFY = /*#__PURE__*/function (JUSTIFY) {
  JUSTIFY["START"] = "start";
  JUSTIFY["CENTER"] = "center";
  JUSTIFY["END"] = "end";
  JUSTIFY["BETWEEN"] = "between";
  JUSTIFY["AROUND"] = "around";
  return JUSTIFY;
}({});
const justifyClasses = exports.justifyClasses = {
  [JUSTIFY.START]: "justify-start",
  [JUSTIFY.CENTER]: "justify-center",
  [JUSTIFY.END]: "justify-end",
  [JUSTIFY.BETWEEN]: "justify-between",
  [JUSTIFY.AROUND]: "justify-around",
  [_mediaQuery.QUERIES.LARGEDESKTOP]: {
    [JUSTIFY.START]: "ld:justify-start",
    [JUSTIFY.CENTER]: "ld:justify-center",
    [JUSTIFY.END]: "ld:justify-end",
    [JUSTIFY.BETWEEN]: "ld:justify-between",
    [JUSTIFY.AROUND]: "ld:justify-around"
  },
  [_mediaQuery.QUERIES.DESKTOP]: {
    [JUSTIFY.START]: "de:justify-start",
    [JUSTIFY.CENTER]: "de:justify-center",
    [JUSTIFY.END]: "de:justify-end",
    [JUSTIFY.BETWEEN]: "de:justify-between",
    [JUSTIFY.AROUND]: "de:justify-around"
  },
  [_mediaQuery.QUERIES.TABLET]: {
    [JUSTIFY.START]: "tb:justify-start",
    [JUSTIFY.CENTER]: "tb:justify-center",
    [JUSTIFY.END]: "tb:justify-end",
    [JUSTIFY.BETWEEN]: "tb:justify-between",
    [JUSTIFY.AROUND]: "tb:justify-around"
  },
  [_mediaQuery.QUERIES.LARGEMOBILE]: {
    [JUSTIFY.START]: "lm:justify-start",
    [JUSTIFY.CENTER]: "lm:justify-center",
    [JUSTIFY.END]: "lm:justify-end",
    [JUSTIFY.BETWEEN]: "lm:justify-between",
    [JUSTIFY.AROUND]: "lm:justify-around"
  },
  [_mediaQuery.QUERIES.MEDIUMMOBILE]: {
    [JUSTIFY.START]: "mm:justify-start",
    [JUSTIFY.CENTER]: "mm:justify-center",
    [JUSTIFY.END]: "mm:justify-end",
    [JUSTIFY.BETWEEN]: "mm:justify-between",
    [JUSTIFY.AROUND]: "mm:justify-around"
  }
};
const getJustifyClasses = (justify, viewport) => {
  const root = viewport ? justifyClasses[viewport] : justifyClasses;
  return root[justify];
};
exports.getJustifyClasses = getJustifyClasses;
var _default = exports.default = getJustifyClasses;